angular
  .module('analysis.module', [
    'ui.router'
  ]);
